
import React, { Component } from 'react';
import Message from './Messages';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MessageList = function (_Component) {
  _inherits(MessageList, _Component);

  function MessageList() {
    _classCallCheck(this, MessageList);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  MessageList.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.scrollOrNot) {
      this.scrollList.scrollTop = this.scrollList.scrollHeight;
    }
  };

  MessageList.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      'div',
      {
        className: 'sc-message-list', ref: function ref(el) {
          return _this2.scrollList = el;
        },
        onScroll: (e) => {
          const bottom = e.target.scrollHeight === e.target.clientHeight + e.target.scrollTop;
          if (e.target.scrollTop === 0) {
            this.props.scrollToTop()
          }
        }
      },
      this.props.messages.map(function (message, i) {
        return React.createElement(Message, { message: message, key: i });
      })
    );
  };

  return MessageList;
}(Component);

export default MessageList;